<template>
  <div class="tw-pb-8 tw-bg-white">
    <div class="row row-eq-height text-center dashboard-metrics -tw-mt-1.5">
      <MetricsBox
        v-if="sharedJobsPermission"
        :metric="sharedJobsCount"
        :sub-text="getSubtext($tc(':count Shared jobs', sharedJobsCount))"
        :link="laravelNamedRoute(namedRoutes.frontend.jobs['shared-with-recruiter'])"
      />
      <MetricsBox
        v-if="unansweredConversationsPermission"
        :metric="unansweredConversationsCount"
        :sub-text="getSubtext($tc(':count Unanswered conversations', unansweredConversationsCount))"
        :link="laravelNamedRoute(namedRoutes.messages.index, { list: 'unresponded' })"
        :emphasized="unansweredConversationsCount > 0"
      />
      <MetricsBox
        v-if="unapprovedBillsPermission"
        :metric="unapprovedBillsCount"
        :sub-text="getSubtext($tc(':count Pending bills', unapprovedBillsCount))"
        :link="laravelNamedRoute(namedRoutes.placements.bills)"
      />
      <MetricsBox
        v-if="placementsPermission"
        :metric="placementsCount"
        :sub-text="getSubtext($tc(':count Placements', placementsCount))"
        :link="laravelNamedRoute(namedRoutes.placements.index)"
      />
      <MetricsBox
        v-if="candidatesPermission"
        :metric="candidatesCount"
        :sub-text="getSubtext($tc(':count Candidates', candidatesCount))"
        :link="laravelNamedRoute(namedRoutes['recruiter-candidates'].index)"
      />
    </div>
  </div>
</template>

<script setup>
import MetricsBox from '@/components/RecruiterDashboard/MetricsBox.vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

defineProps({
  sharedJobsPermission: {
    type: Boolean,
    default: false,
  },
  sharedJobsCount: {
    type: Number,
    default: 0,
  },

  placementsPermission: {
    type: Boolean,
    default: false,
  },
  placementsCount: {
    type: Number,
    default: 0,
  },

  unapprovedBillsPermission: {
    type: Boolean,
    default: false,
  },
  unapprovedBillsCount: {
    type: Number,
    default: 0,
  },

  unansweredConversationsPermission: {
    type: Boolean,
    default: false,
  },
  unansweredConversationsCount: {
    type: Number,
    default: 0,
  },

  candidatesPermission: {
    type: Boolean,
    default: false,
  },
  candidatesCount: {
    type: Number,
    default: 0,
  },
})

const getSubtext = (str) => {
  const spaceIndex = str.indexOf(' ')

  return spaceIndex ? str.substring(spaceIndex + 1) : str
}
</script>
